export enum RateEnum {
    STARTER = 'STARTER',
    PRO = 'PRO',
    BUSINESS = 'BUSINESS',
}